import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class PairComparisonApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor, pairComparisonParams } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const data = pairComparisonParams.reduce((acc, pair) => {
            acc.push({
                answer: pair.answer1_id,
                bool: pair.answer1_id === value?.[pair.pairNumber],
                int: pair.pairNumber,
            });
            acc.push({
                answer: pair.answer2_id,
                bool: pair.answer2_id === value?.[pair.pairNumber],
                int: pair.pairNumber,
            });

            return acc;
        }, []);

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ params: { required }, responseActor }: QuestionContext): boolean {
        const { value } = responseActor.getSnapshot().context;

        if (!required) return true;

        return Boolean(value);
    }
}
